import { Check } from '@mui/icons-material';
import { StepConnector, StepIconProps, stepConnectorClasses, styled } from '@mui/material';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { ImportDataStage } from '.';
import Text from '../../../../../react-components/Text';

const StepperConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 11,
    left: `-50%`,
    right: `50%`,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: RoutalPalette.neutral10,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: RoutalPalette.neutral10,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: RoutalPalette.primary40,
    borderRadius: 1,
  },
}));

const StepperIconBase = styled(`div`)<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ ownerState }) => ({
  backgroundColor: RoutalPalette.neutral00,
  zIndex: 1,
  color: RoutalPalette.primary40,
  width: 24,
  height: 24,
  display: `flex`,
  borderRadius: `50%`,
  justifyContent: `center`,
  alignItems: `center`,
  border: `2px solid ${RoutalPalette.primary40}`,
  ...(ownerState.active && {
    border: `2px solid ${RoutalPalette.primary40}`,
    backgroundColor: RoutalPalette.primary40,
    color: RoutalPalette.neutral00,
  }),
  ...(ownerState.completed && {
    border: `2px solid ${RoutalPalette.neutral10}`,
    backgroundColor: RoutalPalette.neutral10,
    color: RoutalPalette.neutral00,
  }),
}));

function StepperIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <StepperIconBase ownerState={{ completed, active }} className={className}>
      {completed ? (
        <Check style={{ height: 18, width: 18 }} />
      ) : (
        <Text variant="body-medium" addDefaultColor={false} style={{ fontWeight: 500 }}>
          {props.icon}
        </Text>
      )}
    </StepperIconBase>
  );
}

interface StepperHeaderProps {
  stage: ImportDataStage;
  shouldUsePickups: boolean;
  shouldUseTasks: boolean;
}

export const StepperHeader = ({ stage, shouldUsePickups, shouldUseTasks }: StepperHeaderProps) => {
  const availableStages: ImportDataStage[] = [`map_stop_fields`];
  if (shouldUseTasks) {
    availableStages.push(`map_task_fields`);
  }
  if (shouldUsePickups) {
    availableStages.push(`map_pickup_fields`);
  }
  availableStages.push(`review_addresses`);

  return (
    <Stepper
      activeStep={availableStages.indexOf(stage)}
      alternativeLabel
      connector={<StepperConnector />}
      style={{ alignItems: `center` }}
    >
      {availableStages.map((_stage, idx) => {
        const completed = idx < availableStages.indexOf(stage);

        return (
          <Step key={_stage}>
            <StepLabel
              StepIconComponent={StepperIcon}
              sx={{
                '.MuiStepLabel-label.MuiStepLabel-alternativeLabel': { marginTop: `6px` },
              }}
            >
              <Text
                variant="body-large"
                intlId={`plans.dialogs.upload_stops.${_stage}`}
                style={{
                  color: completed ? RoutalPalette.neutral10 : RoutalPalette.primary40,
                  fontWeight: 500,
                }}
              />
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};
